import request from "@/utils/http/requset";

export function getReportTbApi(data) {
  return request({
    url: "/manage/report/recharge/m10",
    method: "post",
    ContentType: "application/json;charset=UTF-8",
    data: data
  });
}

export function getReportBigTbApi(data) {
  return request({
    url: "/manage/report/recharge/b10",
    method: "post",
    ContentType: "application/json;charset=UTF-8",
    data: data
  });
}

export function getReportDayTbApi(data) {
  return request({
    url: "/manage/report/recharge/day",
    method: "post",
    ContentType: "application/json;charset=UTF-8",
    data: data
  });
}


export function getEachartsApi(data) {
  return request({
    url: "/manage/report/recharge/search",
    method: "post",
    ContentType: "application/json;charset=UTF-8",
    data: data
  });
}


export function getChannelLabelListApi(data) {
  return request({
    url: "/manage/report/channel/label",
    method: "post",
    ContentType: "application/json;charset=UTF-8",
    data: data
  });
}

export function getChannelDataApi(data) {
  return request({
    url: "/manage/report/channel/data/list",
    method: "post",
    ContentType: "application/json;charset=UTF-8",
    data: data
  });
}

export function downloadChannelDataApi(data) {
  return request({
    url: "/manage/report/channel/data/download",
    method: "post",
    ContentType: "application/json;charset=UTF-8",
    data: data,
    responseType: 'blob'
  });
}

export function getMerchantDataListApi(data) {
  return request({
    url: "/manage/report/merchant/data/list",
    method: "post",
    ContentType: "application/json;charset=UTF-8",
    data: data
  });
}
export function getMerchantDataList4AdminApi(data) {
  return request({
    url: "/manage/report/merchant/data/list/4admin",
    method: "post",
    ContentType: "application/json;charset=UTF-8",
    data: data
  });
}

export default {
  getReportTbApi,
  getReportBigTbApi,
  getReportDayTbApi,
  getMerchantDataListApi,
  getMerchantDataList4AdminApi,
};
